import {
  InputHTMLAttributes,
  useId, 
} from 'react';
import { CheckIcon } from 'lucide-react';

import { cn } from 'utils/cn';

interface Props extends InputHTMLAttributes<HTMLInputElement> {}

const Checkbox = ({ checked, className, ...props }: Props) => {
  const id = useId();

  return (
    <label htmlFor={id} className={cn('block relative cursor-pointer select-none w-5 h-5', className)}>
      <input
        id={id}
        type="checkbox"
        className="absolute opacity-0 h-0 w-0 cursor-pointer"
        checked={checked}
        {...props}
      />
      <div
        className={cn(
          'flex items-center justify-center w-full h-full border-2 border-grey300 bg-white rounded-sm transition-all duration-200',
          {
            'bg-[#007AC1] border-[#007AC1]': checked,
          },
        )}
      >
        {checked && (
          <CheckIcon strokeWidth={5} className='text-white'/>
        )}
      </div>
    </label>
  );
};

export default Checkbox;
